import { mountFitnessApp, unmountFitnessApp } from '../../src/fitness.jsx';

/**
 * FitLife Pro — React fitness app mounted into the existing site.
 * Navigate via sidebar "Fitness" or window.app.handleNavigation('fitness').
 */
export class Fitness {
    constructor(containerId) {
        this.containerId = containerId;
        this.rootId = 'fitness-root';
    }

    init() {
        const el = document.getElementById(this.containerId);
        if (!el) return;

        document.body.classList.add('fitness-active');
        el.innerHTML = `<div id="${this.rootId}" class="fitness-mount"></div>`;
        mountFitnessApp(this.rootId);
    }

    destroy() {
        unmountFitnessApp();
        document.body.classList.remove('fitness-active');
        const el = document.getElementById(this.containerId);
        if (el) el.innerHTML = '';
    }
}
